import React from 'react';
import Navbar from './Sections/Navbar';
import { Link } from '../../env';
import Marquee from 'react-fast-marquee';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import NextArrow from './Sections/NextArrow';
import PrevArrow from './Sections/PrevArrow';
import Home from './Sections/Home';
import Commercial from './Sections/Commercial';
import Tutorials from './Sections/Tutorials';
import Downloads from './Sections/Downloads';
import Footer from './Sections/Footer';
const DesktopComponents = () => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true, // Add this line to remove arrows
        nextArrow: <NextArrow
            class1='text-white absolute top-0 right-0 z-[999999] h-full flex justify-center items-center -translate-x-[50px] 2xl:translate-x-[10px] 2xl:translate-y-[40px]'
            class2='w-[30px] cursor-pointer'
            status={true} />,
        prevArrow: <PrevArrow
            class1='text-white absolute z-[99999] top-0 left-0 h-full flex items-center justify-center translate-x-[50px] 2xl:translate-y-[40px] 2xl:translate-x-[10px]'
            class2='w-[30px] rotate-180 cursor-pointer'
            status={true} />
    };
    const Links = [
        {
            img: `${Link}assets/CarsBrands/Lifan.png`,
        },
        {
            img: `${Link}assets/CarsBrands/Nissan.png`,
        },
        {
            img: `${Link}assets/CarsBrands/Toyota.png`,
        },
        {
            img: `${Link}assets/CarsBrands/bmw.png`,
        },
        {
            img: `${Link}assets/CarsBrands/chery.png`,
        },
        {
            img: `${Link}assets/CarsBrands/ford.png`,
        },
        {
            img: `${Link}assets/CarsBrands/hyunda.png`,
        },
        {
            img: `${Link}assets/CarsBrands/irankhodro.png`,
        },
        {
            img: `${Link}assets/CarsBrands/kia.png`,
        },
        {
            img: `${Link}assets/CarsBrands/mazda.png`,
        },
        {
            img: `${Link}assets/CarsBrands/mercedes.png`,
        },
        {
            img: `${Link}assets/CarsBrands/misbishi.png`,
        },
        {
            img: `${Link}assets/CarsBrands/parskhodro.png`,
        },
        {
            img: `${Link}assets/CarsBrands/saipa.png`,
        },
    ]
    return (
        <section className='w-full min-h-screen relative'>
            <div className='w-full'>
                <Navbar />
            </div>
            <div className='w-full h-[70px] flex justify-center sticky top-0 left-0 z-[999999] bg-[#f0f3f4]'>
                <div className='container'>
                    <div className='w-full h-full flex justify-center items-center'>
                        <ul className='w-full flex justify-between px-11'>
                            <li className='text-lg font-semibold cursor-pointer poppins-medium'><a href='#home'>Home</a></li>
                            <li className='text-lg font-semibold cursor-pointer poppins-medium'><a href='#tutorial'>Tutorials</a></li>
                            <li className='text-lg font-semibold cursor-pointer poppins-medium'><a href='#download'>Downloads</a></li>
                            <li className='text-lg font-semibold cursor-pointer poppins-medium'><a href='#contactus'>Contact us</a></li>
                            <li className='text-lg font-semibold cursor-pointer poppins-medium'><a href='#signin'>Signin</a></li>
                            <li className='text-lg font-semibold cursor-pointer poppins-medium'><a href='#signup'>Signup</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='w-full h-[110vh] relative'>
                <div className='w-full h-full absolute top-0 z-0'>
                    <img src={`${Link}assets/LandingPageWallpaper/LandingPage.jpg`} className='bg-cover w-full h-full' />
                </div>
                <div className='w-full h-full absolute top-0 z-10 bg-[rgba(0,0,0,0.7)]'></div>
                <div className='w-full h-full absolute top-0 z-20'>
                    <div className='w-full h-full relative'>
                        <div className='w-full bottom-0 h-[150px] flex items-center absolute z-30 bg-[rgba(255,255,255,0.3)]'>
                            <Marquee speed={50} gradient={false}>
                                <div className='w-full flex items-center space-x-[200px]'>
                                    {
                                        Links.map((item, index) => {
                                            return (<>
                                                <img src={item.img} className='w-[90px]' />
                                            </>)
                                        })
                                    }
                                    <div></div>
                                </div>
                            </Marquee>
                        </div>
                    </div>
                </div>
                <div className='w-full h-full z-40 absolute top-0 left-0 flex justify-center items-center'>
                    <div className='container'>
                        <Slider {...settings}>
                            <div className='w-full h-[300px] flex justify-center items-center'>
                                <div className='flex flex-col justify-center items-center space-y-10'>
                                    <h1 className='poppins-medium text-white px-14 2xl:px-0 text-[30px] 2xl:text-[40px] text-center'>{`Engine Tuning Reimagined with IRSystemTuning`}</h1>
                                    <p className='poppins-medium text-white px-14 2xl:px-0 text-[20px] 2xl:text-[20px] text-justify w-[90%]'>
                                        {
                                            `Elevate your driving experience with IRSystemTuning, where cutting-edge technology meets engineering
                                            excellence. Our software redefines the standards of engine tuning by providing precision control over
                                            your vehicle’s performance parameters. From real-time analytics to customizable tuning profiles,
                                            IRSystemTuning empowers you to maximize efficiency and power with unparalleled accuracy. Step into the
                                            driver's seat of innovation and tune your engine with tools trusted by industry professionals worldwide.
                                            Optimize your performance, optimize your journey with IRSystemTuning.`
                                        }
                                    </p>
                                </div>
                            </div>
                            <div className='w-full flex justify-center items-center'>
                                <div className='flex flex-col justify-center items-center space-y-10'>
                                    <h1 className='poppins-medium text-white px-14 text-[30px] 2xl:text-[40px] text-center'>{`Precision Engine Performance Optimization`}</h1>
                                    <p className='w-[90%] poppins-medium text-white px-14 text-[20px] 2xl:text-[20px] text-justify'>
                                        {`Unlock the full potential of your vehicle with IRSystemTuning, the leading solution in precision engine
                                        performance optimization. Our advanced software suite offers comprehensive tools to fine-tune engine
                                        parameters, enhancing power, efficiency, and reliability without compromising safety. Designed for both
                                        novice and expert tuners, IRSystemTuning facilitates a seamless integration of real-time diagnostics and
                                        performance metrics, enabling you to achieve optimal vehicle performance. Through meticulous calibration
                                        of air/fuel ratios, ignition timing, and boost pressures, our system ensures every modification maximizes
                                        performance while adhering to the highest standards of engine integrity. Experience the future of
                                        vehicle tuning with IRSystemTuning, where innovation meets precision driving`}
                                    </p>
                                </div>
                            </div>
                        </Slider>
                    </div>
                </div>
            </div>
            <div className='w-full flex justify-center'>
                <div id='home' className='container relative'>
                    <Home />
                </div>
            </div>
            <div className='bg-[#2c3e50] w-full h-[400px] mb-[50px] relative'>
                <Commercial />
            </div>
            <div id='tutorial' className='w-full relative'>
                <Tutorials />
            </div>
            <div className='w-full relative'>
                <Downloads />
            </div>
            <div id='contactus' className='w-full'>
                <Footer />
            </div>
        </section>
    );
}

export default DesktopComponents;
